import React from "react";

import { IBandUserProps } from "Bands/types";
import { FormBuilder } from "shared/components";
import { IFormButtons, IAPIError } from "shared/types";
import { fields, defaultValues as standardDefaultValues } from "./formData";

interface UserBandInfoFormProps {
  isSubmitting?: boolean;
  hasError?: boolean;
  defaultValues?: Record<string, any>;
  buttons?: IFormButtons;
  apiError?: IAPIError | null;
  handleSubmit: (user: IBandUserProps) => void;
  handleClose: () => void;
}

export const UserBandInfoForm: React.FC<UserBandInfoFormProps> = ({
  buttons,
  handleSubmit,
  handleClose,
  hasError,
  defaultValues = standardDefaultValues,
  ...rest
}) => {
  return (
    <FormBuilder
      fields={fields}
      onSubmit={(user: IBandUserProps) => handleSubmit(user)}
      defaultValues={defaultValues}
      globalError
      submitMode="isDirty"
      apiErrorMessage={hasError}
      buttons={buttons}
      {...rest}
    />
  );
};
